/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingsPageMeta_aggregatesListings$ref: FragmentReference;
declare export opaque type AggregatesListingsPageMeta_aggregatesListings$fragmentType: AggregatesListingsPageMeta_aggregatesListings$ref;
export type AggregatesListingsPageMeta_aggregatesListings = {|
  +totalCount: number,
  +edges: ?$ReadOnlyArray<?{|
    +node: {|
      +firstImage: $ReadOnlyArray<{|
        +bucketName: string,
        +fileName: string,
      |}>
    |}
  |}>,
  +$refType: AggregatesListingsPageMeta_aggregatesListings$ref,
|};
export type AggregatesListingsPageMeta_aggregatesListings$data = AggregatesListingsPageMeta_aggregatesListings;
export type AggregatesListingsPageMeta_aggregatesListings$key = {
  +$data?: AggregatesListingsPageMeta_aggregatesListings$data,
  +$fragmentRefs: AggregatesListingsPageMeta_aggregatesListings$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingsPageMeta_aggregatesListings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatesListingConnectionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatesListing",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": "firstImage",
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 1
                }
              ],
              "concreteType": "AggregatesListingImage",
              "kind": "LinkedField",
              "name": "images",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "bucketName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fileName",
                  "storageKey": null
                }
              ],
              "storageKey": "images(first:1)"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AggregatesListingConnectionConnection",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '772c43ba970378a3a51c608588b2dbed';

export default node;
